const LOCAL_FLY_QL_URL = 'http://localhost:3059/fly-ql/graph/query'
const PCLN_GRAPH_URL = '/pws/v0/pcln-graph/'
const FLY_QL_URL = '/pws/v0/fly/graph/query'
const AIR_PRICE_GUIDE_URL = '/pws/v0/fly/priceguide/graph/query'

export { PCLN_GRAPH_URL, FLY_QL_URL, AIR_PRICE_GUIDE_URL, LOCAL_FLY_QL_URL }
